import { connect, ConnectedProps } from 'react-redux';
import { updateType, search } from '../../../../state/actions';
import { StateType } from '../../../../../state/state.types';

const mapState = ({ results }: StateType) => ({
  query: results.autoCorrectedQuery || results.query,
});

const mapDispatch = (dispatch: Function) => ({
  onSeeMore() {
    dispatch(updateType('commentary'));
    dispatch(search({ reason: 'commentary-snippet' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
